import axios from 'axios';
import apiService from '../utils/apiService';

import {
  SET_LOGGED_USER,
  CLEAR_ERROR_USER,
  CLEAR_ERRORS,
  GET_ALLOWED_ACTIONS_START,
  GET_ALLOWED_ACTIONS_SUCCESSFULLY,
  GET_ALLOWED_ACTIONS_ERROR,
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_ERROR,
  GET_LOGGED_IN_USER_START,
} from './types';

import {
  getAllowedActionsPath,
  getLoggedInUserPath,
} from '../constants/apiEndpoints';

import setJWTToken from '../securityUtils/setJWTToken';
import { checkForUserRole } from '../utils';
import { userRoles } from '../constants/globals';
var jwtDecode = require('jwt-decode');

const clearError = () => {
  return {
    type: CLEAR_ERROR_USER,
  };
};

const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};

export const login = (LoginRequest) => async (dispatch) => {
  try {
    const res = await axios.post('/api/user/login', LoginRequest);
    const { token, refreshToken } = res.data;
    localStorage.setItem('jwtToken', token);
    localStorage.setItem('refreshToken', refreshToken);
    setJWTToken(token);
    const decoded = jwtDecode(token);

    dispatch({
      type: SET_LOGGED_USER,
      payload: decoded,
    });

    if (
      checkForUserRole(decoded?.roles, userRoles.MDULS.value) ||
      checkForUserRole(decoded?.roles, userRoles.AUTHORIZED_PERSON.value)
    ) {
      window.location.replace('/requestForSignetApproval');
    } else {
      window.location.replace('/dashboard');
    }
  } catch (err) {}
};

export const logout = () => (dispatch) => {
  localStorage.clear();
  setJWTToken(false);
  dispatch({
    type: SET_LOGGED_USER,
    payload: {},
  });
  window.location.replace('/');
};

export const setTokensAndDecodeToken = (res) => {
  const { token, refreshToken } = res;
  localStorage.setItem('jwtToken', token);
  localStorage.setItem('refreshToken', refreshToken);
  setJWTToken(token);
  const decoded = jwtDecode(token);
  return decoded;
};

export const deleteErrorUser = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const deleteErrors = () => {
  return (dispatch) => {
    dispatch(clearErrors());
  };
};

const getAllowedActionsStart = () => {
  return {
    type: GET_ALLOWED_ACTIONS_START,
  };
};

const getAllowedActionsSuccessfully = (res) => {
  return {
    type: GET_ALLOWED_ACTIONS_SUCCESSFULLY,
    payload: res,
  };
};

const getAllowedActionsUnsuccessfully = (err) => {
  return {
    type: GET_ALLOWED_ACTIONS_ERROR,
    payload: err,
  };
};

const getLoggedInUserStart = () => {
  return {
    type: GET_LOGGED_IN_USER_START,
  };
};

const getLoggedInUserSuccessfully = (res) => {
  return {
    type: GET_LOGGED_IN_USER,
    payload: res,
  };
};

const getLoggedInUserUnsuccessfully = (err) => {
  return {
    type: GET_LOGGED_IN_USER_ERROR,
    payload: err,
  };
};

export const getAllowedActions = () => {
  return (dispatch) => {
    dispatch(getAllowedActionsStart());
    return apiService
      .get(getAllowedActionsPath())
      .then((response) => {
        dispatch(getAllowedActionsSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getAllowedActionsUnsuccessfully(err?.response?.data));
      });
  };
};

export const getLoggedInUser = () => {
  return (dispatch) => {
    dispatch(getLoggedInUserStart());
    return apiService
      .get(getLoggedInUserPath())
      .then((response) => {
        dispatch(getLoggedInUserSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getLoggedInUserUnsuccessfully(err?.response?.data));
      });
  };
};

export const getLoggedInUserData = () => {
  return (dispatch) => {
    return apiService
      .get(getLoggedInUserPath())
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        dispatch(getLoggedInUserUnsuccessfully(err?.response?.data));
      });
  };
};
